import React, { useState, useEffect } from "react";
import "../../assets/css/candidate-tab-form.css";
import "../../assets/css/inner-tabs.css";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import Loader from "../Common/loader";
import { useNavigate } from "react-router-dom";
import SCOTRadio from "./scotRadio";
import SCOTText from "./scotText";
import SCOTCheckbox from "./scotCheckbox";
import SCOTDate from "./scotDate";
import SCOTSingleFileUpload from "./scotSingleFileUpload";
import {
  saveScotDisc,
  deleteScotDisc,
} from "../../Actions/scotlandDisclosureActions";
import { getPincode } from "../../Actions/pincodeAction";
import DownloadIcon from "../../assets/img/download-icon-black.svg";
import SCOTSelect from "./scotSelect";
import { readyException } from "jquery";
import { validatePincode } from "../../Helper/common";
import { dateFormat } from "../../Helper/common";

const MainForm = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { scotDisc, active, countries } = props;
  const [loading, setLoading] = useState(false);
  const [scotDisclosure, setScotDisc] = useState({});
  const [errorData, setErrorData] = useState({});
  const [activeTab, setActiveTab] = useState(1);
  const [isIndia, setIsIndia] = useState([]);
  const [isSsn, setIsSsn] = useState([]);
  const [tillDateChecked, setTillDateChecked] = useState({});
  const storeData = useSelector((state) => state.scotlandSaveData);
  const { scotlandSaveData, loading: scotlandSaveDataLoading } = storeData;
  const [uploadedFilesCount, setUploadedFilesCount] = useState({});
  const [noSsnChecked, setNoSsn] = useState({});
  const [maxDOJ, setMaxDOJ] = useState({});
  const [minDOL, setMinDOL] = useState({});
  const [unsavedErrorData, setUnsavedErrorData] = useState({});
  const [currentField, setCurrentField] = useState(null);

  let user = JSON.parse(localStorage.getItem('userVerificationCandidate'));
  let clientId;

  if(user && (user?.client_id || user?.bridge_client_id)){
    clientId = user?.client_id || user?.bridge_client_id;  
  }

  useEffect(() => {
    setScotDisc(scotDisc);
  }, [scotDisc]);

  useEffect(() => {
    if (
      typeof scotlandSaveData.data !== "undefined" &&
      scotlandSaveData.data !== null
    ) {
      const group = scotlandSaveData.data.group
        ? scotlandSaveData.data.group.group_id
        : "";
      const reference = scotlandSaveData.data.reference_number;
      if (group == "profile_preview") {
        navigate(`/case-initiation/profile-preview/${reference}`);
        dispatch(deleteScotDisc());
      } else if (typeof group != "undefined" && group != "") {
        navigate(`/case-initiation/check-detail/${reference}/${group}`);
        dispatch(deleteScotDisc());
      }
    }
  }, [scotlandSaveData]);

  useEffect(() => {
    setLoading(props.isLoading);
  }, [props.isLoading]);

  const handleRadioChange = (radioValues) => {
    const { dataset, value } = radioValues;
    setCurrentField(dataset.fieldname);
    if (dataset.fieldname === "address_belongs_to") {
      const india = value === "Within India" ? true : false;
      let updatedIndia = _.cloneDeep(isIndia);
      updatedIndia[parseInt(dataset.checkdetailsindex)] = india;
      setIsIndia(updatedIndia);
    }
    handleErrorData(dataset.fieldname, value != "" ? false : true);
    updateScotLandDetails(dataset, value);
  };

  const handleSelectChange = (selectValues) => {
    const { dataset, value } = selectValues;
    setCurrentField(dataset.fieldname);
    const ssn = value == 2 ? true : false;
    let updatedSsn = _.cloneDeep(ssn);
    updatedSsn = ssn;
    setIsSsn(updatedSsn);
    handleErrorData(dataset.fieldname, value != "" ? false : true);
    updateScotLandDetails(dataset, value);
  };

  const handleTextChange = (textValues) => {
    const { dataset, value } = textValues;
    let scotDetails = _.cloneDeep(scotDisclosure);
    console.log(scotDetails.checksDetails[0].fields);
    setCurrentField(dataset.fieldname);
    let fieldName = textValues.dataset.fieldname;
    if (fieldName === "pin_code" && isIndia[0] === true) {
      let pinArr = [];
      pinArr[0] = textValues;
      let valid = validatePincode(pinArr[0].value);
      if (valid) {
        dispatch(getPincode(pinArr));
      }
      const updatedErrorData = Object.assign({}, errorData);
      updatedErrorData["pin_code"] = !valid;
      updatedErrorData["city"] = !valid;
      updatedErrorData["location"] = !valid;
      setErrorData(updatedErrorData);
      setUnsavedErrorData(updatedErrorData);
      // handleErrorData(dataset.fieldname, !valid);
    } else {
      handleErrorData(dataset.fieldname, value != "" ? false : true);
    }
    updateScotLandDetails(dataset, value);
  };

  const handleErrorData = (field, val) => {
    let newData = Object.assign({}, errorData);
    newData[field] = val;
    setErrorData(newData);
    setUnsavedErrorData(newData);
  };

  const storePincodeData = useSelector((state) => state.pincode);
  const { pincodeData } = storePincodeData;
  useEffect(() => {
    if (
      typeof scotDisclosure.checksDetails !== "undefined" &&
      scotDisclosure.checksDetails !== null
    ) {
      if (
        typeof pincodeData.data !== "undefined" &&
        pincodeData.data !== null
      ) {
        let scotDetails = _.cloneDeep(scotDisclosure);
        scotDetails.checksDetails[0].fields["city"].field_value =
          pincodeData.data.city_name;
        scotDetails.checksDetails[0].fields["location"].field_value =
          pincodeData.data.state_name;
        setScotDisc(scotDetails);
        const updatedErrorData = Object.assign({}, errorData);
        updatedErrorData["city"] = false;
        updatedErrorData["location"] = false;
        setErrorData(updatedErrorData);
      }
    }
  }, [pincodeData, storePincodeData]);

  const handleCheckboxChange = (checkboxValues) => {
    const { dataset, value } = checkboxValues;
    setCurrentField(dataset.fieldname);
    if (dataset.fieldname === "till_date") {
      //let savedDate = dateFormat("DD-MM-YYYY", new Date());
      let updatedTillDateChecked = _.cloneDeep(tillDateChecked);
      const updatedValue =
        updatedTillDateChecked[parseInt(dataset.checkdetailsindex)] === true
          ? ""
          : "1";
      if (updatedValue == "") {
        handleErrorData("residing_from", false);
      }
      handleErrorData("till_date", false);
      updatedTillDateChecked[parseInt(dataset.checkdetailsindex)] =
        !updatedTillDateChecked[parseInt(dataset.checkdetailsindex)];
      setTillDateChecked(updatedTillDateChecked);
      //let savedDate = '';
      updateScotLandDetails(dataset, updatedValue);
    }

    if (dataset.fieldname === "no_ssn") {
      let updatedNoSsn = _.cloneDeep(noSsnChecked);
      const updatedValue =
        updatedNoSsn[parseInt(dataset.checkdetailsindex)] === true ? "" : "1";

      updatedNoSsn[parseInt(dataset.checkdetailsindex)] =
        !updatedNoSsn[parseInt(dataset.checkdetailsindex)];
      setNoSsn(updatedNoSsn);
      let scotDetails = _.cloneDeep(scotDisclosure);
      if (updatedValue == 1) {
        scotDetails.checksDetails[0].fields["ssn"].is_mandatory = 0;
      } else {
        scotDetails.checksDetails[0].fields["ssn"].is_mandatory = 1;
      }
      setScotDisc(scotDetails);
    }
  };

  const handleSaveDate = (checkDetailsIndex, fieldName, savedDate) => {
    setCurrentField(fieldName);
    // const unsavedData = Object.assign({} , errorData);
    // setUnsavedErrorData(unsavedData);
    handleErrorData(fieldName, false);
    let updatedScotDetails = _.cloneDeep(scotDisclosure);
    for (var i in updatedScotDetails.checksDetails[parseInt(checkDetailsIndex)]
      .fields) {
      if (i == fieldName) {
        updatedScotDetails.checksDetails[parseInt(checkDetailsIndex)].fields[
          i
        ].field_value = savedDate;
      }
    }
    setScotDisc(updatedScotDetails);
  };

  const updateScotLandDetails = (dataset, value, dolVal = "") => {
    let scotDetails = _.cloneDeep(scotDisclosure);
    scotDetails.checksDetails[parseInt(dataset.checkdetailsindex)].fields[
      dataset.fieldname
    ].field_value = value;
    // if (dataset.fieldname === "till_date") {
    //   scotDetails.checksDetails[parseInt(dataset.checkdetailsindex)].fields[
    //     "residing_from"
    //   ].field_value = dolVal;
    // }
    setScotDisc(scotDetails);
  };

  const saveHandler = async (e, caseCheckId, index) => {
    props.setIsLoading(true);
    e.preventDefault();
    let hasError = false;
    let errorArr = [];
    let obj = {};
    if (
      typeof scotDisclosure.checksDetails !== "undefined" &&
      scotDisclosure.checksDetails !== null
    ) {
      const checksDetails = scotDisclosure.checksDetails;
      for (var j in checksDetails[0].fields) {
        let isFieldMandatory = checksDetails[index - 1].fields[j].is_mandatory;
        if (j == "till_date") {
          isFieldMandatory =
            checksDetails[index - 1].fields["residing_from"] &&
            checksDetails[index - 1].fields["residing_from"].field_value != ""
              ? 0
              : 1;
          checksDetails[index - 1].fields[j].is_mandatory = isFieldMandatory;
        }
        if (j == "residing_from") {
          const isTillDateChecked =
            tillDateChecked[index - 1] && tillDateChecked[index - 1] == true
              ? true
              : false;
          if (isTillDateChecked) {
            checksDetails[index - 1].fields[j].is_mandatory = 0;
          }
        }
        const fieldArr = [209, 210];
        if (isSsn === true) {
          if (
            checksDetails[0].fields[j].is_mandatory == 1 &&
            (checksDetails[0].fields[j].field_value.trim() == "" ||
              checksDetails[0].fields[j].field_value == null)
          ) {
            hasError = true;
            errorArr[j] = true;
          } else {
            if (j === "pin_code" && isIndia[0] === true) {
              let valid = validatePincode(
                checksDetails[0].fields[j].field_value
              );
              if (valid === false) {
                hasError = true;
              }
              errorArr[j] = !valid;
            } else {
              errorArr[j] = false;
            }
          }
        } else {
          if (
            checksDetails[0].fields[j].is_mandatory == 1 &&
            (checksDetails[0].fields[j].field_value.trim() == "" ||
              checksDetails[0].fields[j].field_value == null)
          ) {
            if (
              fieldArr.includes(checksDetails[0].fields[j].ibridge_field_id)
            ) {
              if (
                checksDetails[0].fields[j].ibridge_field_id == 209 &&
                isIndia[0] === false
              ) {
                errorArr[j] = true;
              } else {
                errorArr[j] = false;
              }
            } else {
              hasError = true;
              errorArr[j] = true;
            }
          } else {
            if (j === "pin_code" && isIndia[0] === true) {
              let valid = validatePincode(
                checksDetails[0].fields[j].field_value
              );
              if (valid === false) {
                hasError = true;
              }
              errorArr[j] = !valid;
            } else {
              errorArr[j] = false;
            }
          }
        }
      }

      // Validation for upload document
      if (
        checksDetails[0].required_documents[0].is_mandatory == 1 &&
        uploadedFilesCount[0][checksDetails[0].required_documents[0].id] == 0
      ) {
        hasError = true;
        errorArr["upload_document"] = true;
      } else {
        errorArr["upload_document"] = false;
      }
      // validation for residing_to when till date is selected
      // if(checksDetails[0].fields['till_date'].field_value != ""){
      //   errorArr["residing_from"] = false;
      //   hasError = hasError ? hasError : false;
      // }else if(checksDetails[0].fields['residing_from'].field_value == ""){
      //   errorArr["residing_from"] = true;
      //   hasError = true;
      // }else{
      //   errorArr["residing_from"] = false;
      //   hasError = hasError ? hasError : false;
      // }
      // validation for country
      if (
        checksDetails[0].fields["country"].is_mandatory == 1 &&
        checksDetails[0].fields["address_belongs_to"].field_value ===
          "Outside India" &&
        (checksDetails[0].fields["country"].field_value.trim() == "" ||
          checksDetails[0].fields["country"].field_value.trim() == null)
      ) {
        errorArr["country"] = true;
        hasError = true;
      }
    }

    setErrorData(errorArr);
    if (hasError == true) {
      props.setIsLoading(false);
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
      return;
    } else {
      saveScotlandDetails(index - 1, caseCheckId);
    }
  };

  const saveScotlandDetails = (checksDetailsIndex, caseCheckId) => {
    let savedDetailsObj = {};
    const fieldDetails = _.cloneDeep(
      scotDisclosure.checksDetails[checksDetailsIndex].fields
    );
    savedDetailsObj["group"] = "scotland_disclosure";
    for (var i in fieldDetails) {
      if (
        fieldDetails[i].field_value !== "" &&
        fieldDetails[i].field_value !== null
      ) {
        if (fieldDetails[i].ibridge_field_id == 209 && isIndia[0] === true) {
        } else {
          savedDetailsObj[`${fieldDetails[i].id}`] =
            fieldDetails[i].field_value;
        }
      }
    }
    props.setIsLoading(false);
    let finalData = {};
    finalData[`${caseCheckId}`] = savedDetailsObj;
    dispatch(saveScotDisc(caseCheckId, finalData, activeTab));
  };

  const getUpdatedScotlandData = () => {
    setCurrentField("upload_document");
    props.reRenderAgain(scotDisclosure);
  };

  // const reRenderAgain = () => {
  //   props.reRenderAgain();
  // };

  useEffect(() => {
    if (
      typeof scotDisclosure.checksDetails !== "undefined" &&
      scotDisclosure.checksDetails !== null
    ) {
      const checksDetails = scotDisclosure.checksDetails;
      const india =
        checksDetails[0].fields.address_belongs_to.field_value ===
          "Within India" ||
        checksDetails[0].fields.address_belongs_to.field_value === ""
          ? true
          : false;
      let updatedIndia = _.cloneDeep(isIndia);
      updatedIndia[0] = india;
      setIsIndia(updatedIndia);
      const ssn =
        checksDetails[0].fields.country.field_value == 2 ? true : false;
      let updatedSsn = _.cloneDeep(ssn);
      updatedSsn = ssn;
      setIsSsn(updatedSsn);
      let updatedTillDateChecked = _.cloneDeep(tillDateChecked);
      updatedTillDateChecked[0] =
        checksDetails[0].fields.till_date.field_value == 1 ? true : false;
      setTillDateChecked(updatedTillDateChecked);
      getUploadedFilesCount(checksDetails);
      setDateConditions(checksDetails);
      let obj = {};
      let errorArr = [];
      for (var j in checksDetails[0].fields) {
        if (
          j === "pin_code" &&
          checksDetails[0].fields[j].field_value !== "" &&
          india === true
        ) {
          let valid = validatePincode(checksDetails[0].fields[j].field_value);
          errorArr[j] = !valid;
        } else {
          errorArr[j] = false;
        }
      }
      errorArr["upload_document"] = false;
      if (Object.keys(unsavedErrorData).length == 0) {
        setErrorData(errorArr);
      } else {
        const newErr = Object.assign({}, unsavedErrorData);
        if (currentField != "pin_code") {
          newErr[currentField] = false;
        }
        setErrorData(newErr);
      }
    }
  }, [scotDisclosure, scotDisc]);

  const getUploadedFilesCount = (checksDetails) => {
    let uploadedFilesCount = {};
    for (let i in checksDetails) {
      let obj = {};
      for (let j in checksDetails[i].required_documents) {
        let count = 0;
        for (let k in checksDetails[i].uploaded_documents) {
          if (
            checksDetails[i].uploaded_documents[k].document_id ==
            checksDetails[i].required_documents[j].id
          ) {
            count++;
          }
        }
        obj[`${checksDetails[i].required_documents[j].id}`] = count;
      }
      uploadedFilesCount[i] = obj;
    }
    setUploadedFilesCount(uploadedFilesCount);
  };

  const setDateConditions = (checksDetails) => {
    let minDol = {};
    let maxDoj = {};
    for (var i in checksDetails) {
      const startDate = checksDetails[i].fields["residing_since"]
        ? checksDetails[i].fields["residing_since"].field_value
        : "";
      const endDate = checksDetails[i].fields["residing_from"]
        ? checksDetails[i].fields["residing_from"].field_value
        : "";
      if (startDate !== "") {
        const [dd, mm, yyyy] = startDate.split("-");
        const futureDate = new Date(`${mm}/${dd}/${yyyy}`);
        futureDate.setDate(futureDate.getDate() + 1);
        minDol[`${i}`] = futureDate;
      } else {
        minDol[`${i}`] = null;
      }

      if (endDate !== "") {
        const [dd, mm, yyyy] = endDate.split("-");
        const pastDate = new Date(`${mm}/${dd}/${yyyy}`);
        pastDate.setDate(pastDate.getDate() - 1);
        maxDoj[`${i}`] = pastDate;
      } else {
        maxDoj[`${i}`] = null;
      }
    }
    setMaxDOJ(maxDoj);
    setMinDOL(minDol);
  };

  const handleSubmitForPreview = (e) => {
    e.preventDefault();
    const currentUrl = window.location.href;
    const [partA, partB] = currentUrl.split("/check-detail/");
    const [reference, route] = partB.split("/");
    navigate(`/case-initiation/profile-preview/${reference}`);
  };

  return (
    <>
      {loading && <Loader />}
      {/* <div className="d-flex justify-content-between align-items-center">
        <ul className="nav nav-tabs address-tabs" id="myTab" role="tablist">
          {activeTab &&
            Object.keys(scotDisclosure).length > 0  && Object.entries(scotDisclosure.checksDetails).map(([key, value]) => {
              const index = parseInt(key) + 1;
              const caseCheckId = value.case_check_id;
              const caseCheckStatus = value.check_status;
              let activeClass = "";
              if (typeof active !== "undefined") {
                if (active == index) {
                  activeClass = "active";
                }
              } else if (index === 1) {
                activeClass = "active";
              }
              let completeClass = "";
              if (caseCheckStatus === 2) {
                completeClass = "completed";
              }
              let check_name = value.IB_CHECK_NAME;
              return (
                <li className="nav-item" key={key}>
                  <a
                    className={`tab nav-link ${activeClass} ${completeClass}`}
                    id={`scot-tab-${index}`}
                    data-toggle="tab"
                    href={`#scot-${index}`}
                    role="tab"
                    aria-controls={`scot-${index}`}
                    aria-selected="true"
                    data-index={index - 1}
                    data-casecheckid={caseCheckId}
                    //style={{ color: caseCheckStatus == 2 ? "green" : "grey" }}
                  >
                    {caseCheckStatus === 2 && (
                      <i class="fas fa-check-circle mr-1"></i>
                    )}
                    {check_name}
                  </a>
                </li>
              );
            })}
        </ul>
      </div>
      <hr /> */}
      <div className="tab-content" id="myTabContent">
        {scotDisclosure.checksDetails &&
          Object.entries(scotDisclosure.checksDetails).map(([key, value]) => {
            const index = parseInt(key) + 1;
            const caseCheckId = value.case_check_id;
            let activeClass = "";
            if (typeof active !== "undefined") {
              if (active == index) {
                activeClass = "show active";
              }
            } else if (index === 1) {
              activeClass = "show active";
            }
            return (
              <div
                className={`tab-pane fade ${activeClass}`}
                id={`scot-${index}`}
                role="tabpanel"
                aria-labelledby={`scot-tab-${index}`}
                key={key}
              >
                <div
                  className="row"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  {value.fields.address_belongs_to ? (
                    <SCOTRadio
                      name={`address_belongs_to_${caseCheckId}`}
                      id={`address_belongs_to_${caseCheckId}`}
                      fieldId={value.fields.address_belongs_to.ibridge_field_id}
                      label={value.fields.address_belongs_to.label}
                      isRequired={value.fields.address_belongs_to.is_mandatory}
                      errId={`err_${caseCheckId}_${value.fields.address_belongs_to.ibridge_field_id}`}
                      options={
                        value.fields.address_belongs_to.getFieldDisplay
                          .optionArray.options
                      }
                      handleRadioChange={handleRadioChange}
                      checkDetailsIndex={key}
                      fieldName={"address_belongs_to"}
                      fieldValue={value.fields.address_belongs_to.field_value}
                      hasError={errorData["address_belongs_to"]}
                    />
                  ) : (
                    <></>
                  )}
                </div>
                <div className="row">
                  {value.fields.address ? (
                    <SCOTText
                      name={`address_${caseCheckId}`}
                      id={`address_${caseCheckId}`}
                      fieldId={value.fields.address.ibridge_field_id}
                      label={value.fields.address.label}
                      isRequired={value.fields.address.is_mandatory}
                      errId={`err_${caseCheckId}_${value.fields.address.ibridge_field_id}`}
                      handleTextChange={handleTextChange}
                      checkDetailsIndex={key}
                      fieldName={"address"}
                      fieldValue={value.fields.address.field_value}
                      hasError={errorData["address"]}
                    />
                  ) : (
                    <></>
                  )}
                  {value.fields.colony_street ? (
                    <SCOTText
                      name={`colony_street_${caseCheckId}`}
                      id={`colony_street_${caseCheckId}`}
                      fieldId={value.fields.colony_street.ibridge_field_id}
                      label={value.fields.colony_street.label}
                      isRequired={value.fields.colony_street.is_mandatory}
                      errId={`err_${caseCheckId}_${value.fields.colony_street.ibridge_field_id}`}
                      handleTextChange={handleTextChange}
                      checkDetailsIndex={key}
                      fieldName={"colony_street"}
                      fieldValue={value.fields.colony_street.field_value}
                      hasError={errorData["colony_street"]}
                    />
                  ) : (
                    <></>
                  )}
                </div>
                <div className="row align-items-center">
                  {value.fields.residing_since ? (
                    <SCOTDate
                      paramStartDate={null}
                      placeholder={value.fields.residing_since.label}
                      name={`residing_since_${caseCheckId}`}
                      id={`residing_since_${caseCheckId}`}
                      fieldId={value.fields.residing_since.ibridge_field_id}
                      label={value.fields.residing_since.label}
                      isRequired={value.fields.residing_since.is_mandatory}
                      errId={`err_${caseCheckId}_${value.fields.residing_since.ibridge_field_id}`}
                      intialStatus={0}
                      saveDate={handleSaveDate}
                      checkDetailsIndex={key}
                      maxDOJDate={maxDOJ[key]}
                      fieldName={"residing_since"}
                      fieldValue={value.fields.residing_since.field_value}
                      hasError={errorData["residing_since"]}
                    />
                  ) : (
                    <></>
                  )}
                  {value.fields.residing_from &&
                  !(
                    tillDateChecked[index - 1] &&
                    tillDateChecked[index - 1] === true
                  ) ? (
                    <SCOTDate
                      paramStartDate={null}
                      placeholder={value.fields.residing_from.label}
                      name={`residing_from_${caseCheckId}`}
                      id={`residing_from_${caseCheckId}`}
                      fieldId={value.fields.residing_from.ibridge_field_id}
                      label={value.fields.residing_from.label}
                      // isRequired={
                      //   value.fields.residing_from.is_mandatory
                      // }
                      isDisabled={
                        tillDateChecked[index - 1] &&
                        tillDateChecked[index - 1] === !true
                          ? true
                          : false
                      }
                      errId={`err_${caseCheckId}_${value.fields.residing_from.ibridge_field_id}`}
                      intialStatus={0}
                      saveDate={handleSaveDate}
                      checkDetailsIndex={key}
                      minDateDOL={minDOL[key]}
                      fieldName={"residing_from"}
                      fieldValue={value.fields.residing_from.field_value}
                      hasError={errorData["residing_from"]}
                      tillDateValue={
                        value.fields.till_date.field_value == "1" ? true : false
                      }
                    />
                  ) : (
                    <></>
                  )}
                  {value.fields.till_date ? (
                    <SCOTCheckbox
                      name={`till_date_${caseCheckId}`}
                      id={`till_date_${caseCheckId}`}
                      fieldId={value.fields.till_date.ibridge_field_id}
                      label={value.fields.till_date.label}
                      isRequired={value.fields.till_date.is_mandatory}
                      errId={`err_${caseCheckId}_${value.fields.till_date.ibridge_field_id}`}
                      handleCheckboxChange={handleCheckboxChange}
                      checkDetailsIndex={key}
                      fieldName={"till_date"}
                      fieldValue={value.fields.till_date.field_value}
                      hasError={errorData["till_date"]}
                    />
                  ) : (
                    <></>
                  )}
                </div>
                <div className="row">
                  {value.fields.pin_code ? (
                    <SCOTText
                      name={`pin_code_${caseCheckId}`}
                      id={`pin_code_${caseCheckId}`}
                      fieldId={value.fields.pin_code.ibridge_field_id}
                      label={value.fields.pin_code.label}
                      isRequired={value.fields.pin_code.is_mandatory}
                      errId={`err_${caseCheckId}_${value.fields.pin_code.ibridge_field_id}`}
                      handleTextChange={handleTextChange}
                      checkDetailsIndex={key}
                      fieldName={"pin_code"}
                      fieldValue={value.fields.pin_code.field_value}
                      hasError={errorData["pin_code"]}
                    />
                  ) : (
                    <></>
                  )}
                  {value.fields.location ? (
                    <SCOTText
                      name={`location_${caseCheckId}`}
                      id={`location_${caseCheckId}`}
                      fieldId={value.fields.location.ibridge_field_id}
                      label={value.fields.location.label}
                      isRequired={value.fields.location.is_mandatory}
                      errId={`err_${caseCheckId}_${value.fields.location.ibridge_field_id}`}
                      handleTextChange={handleTextChange}
                      checkDetailsIndex={key}
                      fieldName={"location"}
                      fieldValue={value.fields.location.field_value}
                      hasError={errorData["location"]}
                    />
                  ) : (
                    <></>
                  )}
                </div>
                <div className="row">
                  {value.fields.city ? (
                    <SCOTText
                      name={`city_${caseCheckId}`}
                      id={`city_${caseCheckId}`}
                      fieldId={value.fields.city.ibridge_field_id}
                      label={value.fields.city.label}
                      isRequired={value.fields.city.is_mandatory}
                      errId={`err_${caseCheckId}_${value.fields.city.ibridge_field_id}`}
                      handleTextChange={handleTextChange}
                      checkDetailsIndex={key}
                      fieldName={"city"}
                      fieldValue={value.fields.city.field_value}
                      hasError={errorData["city"]}
                    />
                  ) : (
                    <></>
                  )}
                  {value.fields.police_station ? (
                    <SCOTText
                      name={`police_station_${caseCheckId}`}
                      id={`police_station_${caseCheckId}`}
                      fieldId={value.fields.police_station.ibridge_field_id}
                      label={value.fields.police_station.label}
                      isRequired={value.fields.police_station.is_mandatory}
                      errId={`err_${caseCheckId}_${value.fields.police_station.ibridge_field_id}`}
                      handleTextChange={handleTextChange}
                      checkDetailsIndex={key}
                      fieldName={"police_station"}
                      fieldValue={value.fields.police_station.field_value}
                      hasError={errorData["police_station"]}
                    />
                  ) : (
                    <></>
                  )}
                </div>
                <div className="row">
                  {value.fields.landmark_additional_address ? (
                    <SCOTText
                      name={`landmark_additional_address_${caseCheckId}`}
                      id={`landmark_additional_address_${caseCheckId}`}
                      fieldId={
                        value.fields.landmark_additional_address
                          .ibridge_field_id
                      }
                      label={value.fields.landmark_additional_address.label}
                      isRequired={
                        value.fields.landmark_additional_address.is_mandatory
                      }
                      errId={`err_${caseCheckId}_${value.fields.landmark_additional_address.ibridge_field_id}`}
                      handleTextChange={handleTextChange}
                      checkDetailsIndex={key}
                      fieldName={"landmark_additional_address"}
                      fieldValue={
                        value.fields.landmark_additional_address.field_value
                      }
                      hasError={errorData["landmark_additional_address"]}
                    />
                  ) : (
                    <></>
                  )}
                  {value.fields.country && isIndia[0] === false ? (
                    <SCOTSelect
                      name={`country_${caseCheckId}`}
                      id={`country_${caseCheckId}`}
                      label={value.fields.country.label}
                      autoComplete="off"
                      options={countries}
                      isRequired={value.fields.country.is_mandatory}
                      caseCheckId={caseCheckId}
                      handleSelectChange={handleSelectChange}
                      checkDetailsIndex={key}
                      fieldName={"country"}
                      fieldValue={value.fields.country.field_value}
                      hasError={errorData["country"]}
                    />
                  ) : (
                    <></>
                  )}
                </div>
                <div className="row">
                  {value.fields.ssn &&
                  isIndia[0] === false &&
                  isSsn === true ? (
                    <SCOTText
                      name={`ssn_${caseCheckId}`}
                      id={`ssn_${caseCheckId}`}
                      fieldId={value.fields.ssn.ibridge_field_id}
                      label={value.fields.ssn.label}
                      //isRequired={value.fields.ssn.is_mandatory}
                      isRequired={
                        noSsnChecked[0] == true
                          ? 0
                          : value.fields.ssn.is_mandatory
                      }
                      errId={`err_${caseCheckId}_${value.fields.ssn.ibridge_field_id}`}
                      handleTextChange={handleTextChange}
                      checkDetailsIndex={key}
                      fieldName={"ssn"}
                      fieldValue={value.fields.ssn.field_value}
                      hasError={errorData["ssn"]}
                    />
                  ) : (
                    <></>
                  )}
                  {value.fields.ssn &&
                  isIndia[0] === false &&
                  isSsn === true ? (
                    <SCOTCheckbox
                      name={`no_ssn_${caseCheckId}`}
                      id={`no_ssn_${caseCheckId}`}
                      fieldId={"no_ssn"}
                      label={"Not Applicable"}
                      //isRequired={0}
                      fieldValue={noSsnChecked[0] == true ? "1" : ""}
                      handleCheckboxChange={handleCheckboxChange}
                      checkDetailsIndex={key}
                      fieldName={"no_ssn"}
                    />
                  ) : (
                    <></>
                  )}
                </div>
                <div className="row mb-3">
                  <div className="col-sm-12 col-md-12 col-xl-12">
                    <div className="fnt-smi-bld mb-0">Upload document</div>
                    <small className="fnt-smi text-muted">
                      upload your PV form
                    </small>
                  </div>
                </div>
                {/* <div className="row">
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group"> */}
                <SCOTSingleFileUpload
                  name="pv_form"
                  id="pv_form"
                  title={value.required_documents[0].document_name}
                  record={{
                    caseCheckId: caseCheckId,
                    docId: value.required_documents[0].id,
                  }}
                  totalCount={
                    uploadedFilesCount[parseInt(index - 1)] &&
                    uploadedFilesCount[parseInt(index - 1)][
                      value.required_documents[0].id
                    ]
                      ? uploadedFilesCount[parseInt(index - 1)][
                          value.required_documents[0].id
                        ]
                      : 0
                  }
                  getCount={1}
                  getUpdatedScotlandData={getUpdatedScotlandData}
                  isMandatory={value.required_documents[0].is_mandatory}
                  errId={`err_${caseCheckId}_${value.required_documents[0].id}`}
                  value={value}
                  hasError={errorData["upload_document"]}
                />
                {/* </div>
                  </div>
                 
                </div>  */}

                {/* <div className="row mt-3">
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <a href={scotDisclosure.pv_template_url} download>
                      <button class="btn btn-dark remove-btn"> <i class="fa-solid fa-download"></i> Download PV Template</button>
                    </a>
                  </div>
                </div> */}

                <div className="row mt-3">
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <button class="btn btn-dark remove-btn">
                      {" "}
                      <i class="fa-solid fa-download"></i>
                      <a
                        href={scotDisclosure.pv_template_url}
                        download
                        style={{ color: "white", textDecoration: "none" }}
                      >
                        {" "}
                        Download PV Template
                      </a>
                    </button>
                  </div>
                </div>
                {/* <div className=" upload-box">
                    <div className="left d-flex align-items-center">
                      <a href={scotDisclosure.pv_template_url} download="PV Form"><img src={DownloadIcon} alt="" className="remove-btn" /></a>
                      <span>
                        <h6 className="m-2 ml-3">Download PV Template</h6>
                      </span>

                    
                    </div>
                  </div> */}

                <div className="row mt-3">
                  <div className="col-auto d-flex justify-content-between">
                    <button
                      className="btn btn-primary btn-lg btn-block mt-3"
                      onClick={(e) => saveHandler(e, caseCheckId, index)}
                    >
                      Save
                    </button>
                  </div>
                </div>
                {scotDisclosure.showProfilePreview == 1 && (
                  <div className="row">
                    <div className="col-auto d-flex justify-content-between">
                      <button
                        className="btn btn-primary btn-lg btn-block mt-3"
                        onClick={(e) => handleSubmitForPreview(e)}
                      >
                        {clientId == 459831 ? "Preview" : "Submit for Preview"}
                      </button>
                    </div>
                    <div className="col-auto d-flex justify-content-between mt-4">
                      <small className="text-muted">
                        Please complete all the mandatory fields before final
                        submission
                      </small>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
      </div>
    </>
  );
};

export default MainForm;
